var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3P(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H14V11.45C14 10.7167 13.6333 10.125 12.9 9.675C12.1667 9.225 11.2 9 10 9C8.8 9 7.83333 9.225 7.1 9.675C6.36667 10.125 6 10.7167 6 11.45V12ZM10 8C10.55 8 11.0208 7.80417 11.4125 7.4125C11.8042 7.02083 12 6.55 12 6C12 5.45 11.8042 4.97917 11.4125 4.5875C11.0208 4.19583 10.55 4 10 4C9.45 4 8.97917 4.19583 8.5875 4.5875C8.19583 4.97917 8 5.45 8 6C8 6.55 8.19583 7.02083 8.5875 7.4125C8.97917 7.80417 9.45 8 10 8ZM0 20V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H18C18.55 0 19.0208 0.195833 19.4125 0.5875C19.8042 0.979167 20 1.45 20 2V14C20 14.55 19.8042 15.0208 19.4125 15.4125C19.0208 15.8042 18.55 16 18 16H4L0 20ZM3.15 14H18V2H2V15.125L3.15 14Z",
    fill: "#A098AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3P);
export default __webpack_public_path__ + "static/media/3p.f321c88a29b06fb23f57f24baa4980d7.svg";
export { ForwardRef as ReactComponent };